export const PARTICIPANT_TYPES = {
  DOCTOR: 'doctor',
  OTHER: 'other',
};
